/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  jQuery(".js-modal-btn").modalVideo({channel:'vimeo'}); 

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

});


(function( root, $, undefined ) {
  "use strict";

      // toggle the menu
      $('.js-menu').click(function(){

        var $body = $('body'),
            $this = $(this);

        if($body.hasClass('menu-is-open')) {

          $body.removeClass('menu-is-open');

        } else {

          $body.addClass('menu-is-open');

        }

      });

      // file upload label

      $('input[type="file"]').change(function() {
          var filename = $(this).val();
          var lastIndex = filename.lastIndexOf("\\");
          var label = $(this).parent().next('.fileselected');

          if (lastIndex >= 0) {
              filename = filename.substring(lastIndex + 1);
              label.html(filename);
          }
          
      });      

      // custom select
      $('.js-replaceselect').click(function(){

        if($(this).hasClass('replaceselect--active')) {
          $(this).removeClass('replaceselect--active');
        } else {
          $(this).addClass('replaceselect--active');
        }                

      });

      $('.js-select-switch').click(function(){

        var value = $(this).attr('data-value');
        var theDiv = $(".form--" + value);  
        var label = $(this).children(".option__label").html();
        theDiv.addClass("hiddenform--active");
        theDiv.siblings('[class*=hiddenform]').removeClass("hiddenform--active");

        $('.js-replaceselect').addClass('close');
        $('.js-selected').html(label);

      });

      // accordion

        
      var allPanels = $('.accordion > li');
        
      $('.accordion > li > .panel').click(function() {
          var $this = $(this);
          var $target =  $this.parent();

          if(!$target.hasClass('panel--active')){
             allPanels.removeClass('panel--active');
             $target.addClass('panel--active');
          }
          
        return false;
      });
      // $(".js-form-select").change(function(){          
      //     var value = $(".js-form-select option:selected").val();

      //     if(value=='none'){
      //       $(this).siblings('[class*=hiddenform]').removeClass("hiddenform--active");
      //     } else {
      //       var theDiv = $(".form--" + value);          
      //       theDiv.addClass("hiddenform--active");
      //       theDiv.siblings('[class*=hiddenform]').removeClass("hiddenform--active");            
      //     }
      // });

} ( this, jQuery ));